import type { JSX } from "solid-js"
import { Show } from "solid-js"
import { Text } from "@/designSystem/components/text"
import {
  tierDescriptionTextClass,
  tierPublicationLogoClass,
  tierPublicationLogoWrapperClass,
  tierTitleTextClass,
} from "./tier-selection.css"

interface SubscriptionHeaderProps {
  publicationLogoUrl?: string | null
  publicationName: string
  titleText: string
  descriptionContent: JSX.Element
}

export function SubscriptionHeader(props: SubscriptionHeaderProps) {
  return (
    <>
      <Show when={props.publicationLogoUrl}>
        <div class={tierPublicationLogoWrapperClass}>
          <img
            src={props.publicationLogoUrl!}
            alt={props.publicationName}
            class={tierPublicationLogoClass}
          />
        </div>
      </Show>
      <Text
        fontSize="hero3"
        color="sand900"
        textAlign="center"
        fontWeight="700"
        fontFamily="serif"
        class={tierTitleTextClass}
      >
        {props.titleText}
      </Text>
      <Text fontSize="m" color="sand800" class={tierDescriptionTextClass}>
        {props.descriptionContent}
      </Text>
    </>
  )
}
